import styled from "styled-components";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import CustomButton from "../../../helperComponents/CustomButton";
import { BiCalendar, BiExport, BiPlus, BiUser } from "react-icons/bi";
import { GrDisabledOutline } from "react-icons/gr";
import { TbBeach } from "react-icons/tb";
import { GoIssueOpened } from "react-icons/go";
import { useEffect, useState } from "react";
import { serverLine } from "../../../../controllers/network/serverLine";
import CustomPagination from "../../../helperComponents/CustomPagination";
import CustomMasonry from "../../../helperComponents/CustomMasonry";
import LoadingSection from "../../../helperComponents/LoadingSection";
import ListSizeSetter from "../../../helperComponents/ListSizeSetter";
import RoleCard from "./ZoneCard";
import ListPage from "../../../customUiForCs/ListPage";
import NomenclatureOfZone from "../nomenclature/NomenclatureOfZone";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;
  width: 100%;
  margin-top: 30px;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const Content = styled.div`
  padding: 15px;
  border: 1px solid var(--borderDim);
  background: var(--surface2);
  border-radius: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const BottomPart = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export default function ZoneListPage() {
  return (
    <LoggedInBoilerplate titleLine1={"Liste des"} titleLine2={"Zones"}>
      <NomenclatureOfZone
        columns={2}
        buttons={[
          {
            href: "/add-zone",
            text: "ajouter une zone",
            icon: <BiPlus />,
          },
        ]}
      />
    </LoggedInBoilerplate>
  );
}
